<template lang="pug">
section
  div
    | Once you have submitted
    | your online application,
    | you should scan or take pictures
    | of your supporting documents
    | and send them to the email address
    |
    u SponsorLicensingReplies@homeoffice.gov.uk
    |
    | (check the email address
    | on your submission sheet)
    | within
    |
    b 5 working days
    |
    | of the date you complete
    | your online application.

  br

  div
    | ❗
    |
    | In all cases the Home Office
    | reserves the right
    | to request original documents
    | or certified copies
    | and to be sent to them by post.

  br

  div
    | You will need to send following documents:

  ul
    li
      b Submission sheet
      |
      | -
      | signed and dated
      | by your authorising officer
      | with all pages including a declaration
      | from you that you agree
      | to meet all of the duties
      | associated with being a licensed sponsor;
    li
      b All other mandatory documents.

  br

  div
    b Files requirements

  div
    | Scans or picture files can be
    | in PDF (preferred), JPEG or PNG format.

  br

  div
    | File titles should:

  ul
    li
      | be descriptive,
      | e.g. 'Bank statement Apr 2018'
    li
      | be no more than 25 characters long
    li
      | not contain special characters,
      | e.g. # or ?
    li
      | not contain words separated by dots,
      | e.g. 'bank.statement.apr.2018'

  br

  div
    | The total size limit for emails
    | that the Home Office can receive is
    |
    b 20MB.
</template>

<script>
export default {
  name: "submit_oa_docs",
};
</script>